module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_07-68140ffa06b9074afec18c12ed9200f9.webp";